import {type UIChild, UI, type PartialOptions} from "../../stem-core/ui/UIBase";
import {StyleSheet, registerStyle, styleRule} from "../../stem-core/ui/Style";
import {VerticalDotsIcon} from "../../core/ui/SVGElements.jsx";
import {AnchoredPopup} from "../../stem-core/ui/AnchoredPopup.jsx";
import type {ExtendedOptions} from "../../stem-core/ui/UIBase";


class PopupMenuStyle extends StyleSheet {
    @styleRule
    container = {
        cursor: "pointer",
    }

    @styleRule
    menuItem = {
        padding: "6px 12px",
        cursor: "pointer",
        transition: this.themeProps.DEFAULT_TRANSITION,
        userSelect: "none",
        ":hover": {
            background: this.themeProps.DROPDOWN_ITEM_HOVER_BACKGROUND,
        },
    };

    @styleRule
    menuItemDisabled = {
        opacity: this.themeProps.BASE_DISABLED_OPACITY,
        pointerEvents: "none",
        cursor: "not-allowed",
    }
}

// The container that has all the menu options
// TODO @cleanup max height 200px
// One entry of a popup menu, as renderMenuItem reads it
interface PopupMenuItem {
    content: UIChild;
    onClick(): void;
    disabled?: boolean;
}

interface AnchoredMenuPopupOptions {
    items?: PopupMenuItem[];
}

class AnchoredMenuPopup extends AnchoredPopup {
    // AnchoredPopup fixes its own options type and doesn't forward a type argument
    declare options: ExtendedOptions<AnchoredPopup, AnchoredMenuPopupOptions>;

    getDefaultOptions(options?: this["options"]) {
        return {
            ...super.getDefaultOptions(options),
            toggleOnSameAnchor: true,
            testId: "menuPopup"
        }
    }

    renderMenuItem(item: PopupMenuItem) {
        const styleSheet = PopupMenuStyle.getInstance(this.getTheme());

        return <div
            onClick={() => {
                this.hide();
                item.onClick(); // TODO @cleanup should be maybe ".callback()
            }}
            className={styleSheet.menuItem + (item.disabled ? styleSheet.menuItemDisabled : "")}
        >
            {item.content}
        </div>
    }

    render() {
        return this.options.items.map(item => this.renderMenuItem(item));
    }
}


interface PopupMenuOptions {
    items?: PopupMenuItem[];
}

@registerStyle(PopupMenuStyle)
export class PopupMenu extends UI.Element<PopupMenuOptions> {
    getDefaultOptions(): PartialOptions<PopupMenu> {
        return {
            testId: "popupMenu",
        }
    }

    render() {
        return <VerticalDotsIcon size={16}/>
    }

    onMount() {
        this.addClickListener(() => AnchoredMenuPopup.show({
            anchor: this,
            items: this.options.items
        }));
    }
}